import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ roles, children, redirectTo = "/login" }) {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-[#0a0a0a] text-white/60 text-sm tracking-widest uppercase"
        data-testid="auth-loading"
      >
        Authenticating…
      </div>
    );
  }
  if (status !== "authenticated" || !user) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }
  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/forbidden" replace />;
  }
  return children;
}

export function GuestOnlyRoute({ children }) {
  const { status, user } = useAuth();
  if (status === "loading") return null;
  if (status === "authenticated" && user) {
    // Send admins straight to their consoles. Subscribers (and any other role)
    // are NOT redirected away — they may be a viewer who wants to sign in as a
    // studio/admin on the same device, so let them reach the login form.
    if (user.role === "super_admin") return <Navigate to="/admin" replace />;
    if (user.role === "tenant_admin") return <Navigate to="/studio" replace />;
  }
  return children;
}
